<div class="top-bar-container block-background">
  @if (isBack) {
    <mat-icon class="back-icon" (click)="openLocation()">chevron_left</mat-icon>
  } @else {
    <span></span>
  }
  <span class="top-bar-text main-text-color">{{title}}</span>
  <span></span>
</div>
